// @ts-ignore
import { createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { getClientId } from "../helpers/funlib";
import { ng } from "../ngds";
export const fetchAdmin = createAsyncThunk("admin/admin", async (item: any, thunkAPI: any) => {
  const state: any = thunkAPI.getState();
  let token = state.UserSlice.token;
  if (!token) {
    console.error("No token found in Exist");
    return null;
  }
  let resp = await fetch("/api/admin/", {
    method: "POST",
    headers: {
      authorization: `Bearer ${token}`,
      "x-client-id": getClientId(),
    },
  });
  if (!resp.ok) {
    console.error("Failed to fetch admin data", resp.status, resp.statusText);
    return null;
  }
  return await resp.json();
});

export function useAdmin() {
  const dispatch = useDispatch();
  return {
    fetchAdmin: async () => await dispatch(fetchAdmin("")),
    downloadProject: async (guid: string) => await dispatch(downloadProjectWithGuid({ guid })),
  };
}

export const downloadProjectWithGuid = createAsyncThunk(
  "projects/download",
  async (args: { guid: string }, thunkAPI: any) => {
    let state = thunkAPI.getState() as { UserSlice: { token: string | null } };

    const response = await fetch(`/api/admin/downloadproject/${args.guid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: state.UserSlice.token ? `Bearer ${state.UserSlice.token}` : "",
        "x-client-id": getClientId(),
      },
      body: JSON.stringify({ guid: args.guid }),
    });
    if (response.ok) {
      // handle successful response
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${args.guid}.json`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      // handle error
    }
  },
);

export const fillReport = async (
  api: string,
  setReport: (report: ng.endpoint_args.common_api_functions.AdminReport) => any,
) => {
  try {
    const response = await fetch(`/${api}/admin`);
    const d = await response.json();
    let report = ng.endpoint_args.common_api_functions.AdminReport.fromObject(d);
    return report;
  } catch (e) {
    console.log(e);
  }
};
